import { render } from "./Dropdown.vue?vue&type=template&id=5bf592c2"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=5bf592c2&lang=scss"
script.render = render

export default script